import { render, staticRenderFns } from "./VideoImagePreview.vue?vue&type=template&id=51a1960a"
import script from "./VideoImagePreview.vue?vue&type=script&lang=js"
export * from "./VideoImagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports